class DeviceProductForm extends HTMLElement {
  constructor() {
    super()

    // START A/B Test code
    if (window.NOOD_TEST && document.querySelector('[data-is-nood-test]')) {
      // Show Nood Test
      document
        .querySelector('.items-baseline [data-main-product-compare-at-price]')
        .parentElement.classList.add('flex', 'flex-row-reverse', 'items-center', 'gap-1')
      document.querySelector('[data-is-nood-test]').dataset.isNoodTest = true
      document.querySelectorAll('[data-nood-test-active]').forEach((el) => el.classList.remove('hidden'))

      // Remove Control
      document.querySelectorAll('[data-nood-test-control]').forEach((el) => el.remove())
    }
    // END A/B Test code

    this.isNoodTest = document.querySelector('[data-is-nood-test]')?.dataset.isNoodTest ?? false
    this.isNectar = document.querySelector('[data-nectar-addon-offer-toggle-container]')
    if (this.isNoodTest == 'true') {
      this.setupNoodAddToCart()
    } else if (this.isNectar) {
      this.setupNectarAddToCart()
    } else {
      this.setupAddToCart()
    }
    this.setupPriceUpdating()
    this.setupVariantImageUpdating()
    this.setupUpsellModalListeners()
    this.setupNectarUpsell()
  }

  getBundleData() {
    const serumBundleData = this.querySelector('[data-serum-bundle-data]')
    if (serumBundleData) {
      console.log('Serum Bundle Data:', JSON.parse(serumBundleData.textContent))
    }
  }

  setupNoodAddToCart() {
    const serumBundleData = document.querySelector('[data-serum-bundle-data]')

    const serumBundleProducts = serumBundleData ? JSON.parse(serumBundleData.innerHTML) : null

    const $$addToCartButtons = document.querySelectorAll('[data-add-to-cart]')

    $$addToCartButtons.forEach(($addToCartButton) =>
      $addToCartButton.addEventListener('click', () => {
        $addToCartButton.dataset.loading = null

        const addToCartPayload = {
          items: [],
        }

        const bundleDiscountScriptProperty = this.querySelector('[data-bundle-discount-script-property]')
          ? this.querySelector('[data-bundle-discount-script-property]').dataset.bundleDiscountScriptProperty
          : null

        const $purchaseOption = this.querySelector('[name="purchase-option"]:checked').value
        let selling_plan_id = ''
        let variant_id = ''

        // Bundle items
        if ($purchaseOption && $purchaseOption == 'serum-bundle') {
          serumBundleProducts.forEach((product) => {
            if (product.selling_plan_groups) {
              product.selling_plan_groups.forEach((group) => {
                group.selling_plans.forEach((plan) => {
                  if (plan.name.includes('4 weeks')) {
                    selling_plan_id = plan.id
                  }

                  product.variants.forEach((variant) => {
                    if (variant.title.includes('1-Month') || variant.title.includes('1-Pack')) {
                      variant_id = variant.id
                    }
                  })
                })
              })
            }

            addToCartPayload.items.unshift({
              quantity: 1,
              id: variant_id,
              selling_plan: selling_plan_id,
              properties: {
                [bundleDiscountScriptProperty]: true,
              },
            })
          })
        }

        // Main product
        addToCartPayload.items.unshift({
          quantity: 1,
          id: Number(this.getAttribute('variant-id')),
          properties: {
            [$purchaseOption && $purchaseOption == 'serum-bundle'
              ? bundleDiscountScriptProperty
              : '_device_only_exclude']: true,
          },
        })

        const $warranty = this.querySelector('[name="warranty"]:checked')
        if ($warranty && $warranty.value != '') {
          addToCartPayload.items.unshift({
            quantity: 1,
            id: Number($warranty.value),
          })
        }

        const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
        $$addons.forEach(($addon) => {
          if ($addon.value == '') return
          addToCartPayload.items.push({
            quantity: 1,
            id: Number($addon.value),
            properties: {
              _addon: true,
            },
          })
        })

        // Check if upsell modal should be triggered
        if (this.shouldTriggerUpsellModal(addToCartPayload)) {
          const upgradeMapping = this.getUpgradeMapping(addToCartPayload)
          if (upgradeMapping) {
            // Emit event to show upsell modal
            const upsellEvent = new CustomEvent('device-form:show-upsell', {
              detail: {
                addToCartData: addToCartPayload,
                upgradeMapping: upgradeMapping,
                button: $addToCartButton,
              },
            })
            document.dispatchEvent(upsellEvent)
            return // Don't proceed with ATC yet
          }
        }

        // Proceed with normal add to cart
        this.executeAddToCart(addToCartPayload, $addToCartButton)
      })
    )
  }

  setupNectarAddToCart() {
    const $$addToCartButtons = document.querySelectorAll('[data-add-to-cart]')

    function addToCart($addToCartButton) {
      $addToCartButton.dataset.loading = null

      const addToCartPayload = {
        items: [],
      }

      const $main = document.querySelector('[data-nectar-product-handle]')
      const variantId = $main?.getAttribute('data-nectar-variant-id')

      addToCartPayload.items.unshift({
        quantity: 1,
        id: Number(variantId),
      })

      const $addonOfferToggle = document.querySelector('[data-nectar-addon-offer-toggle]')
      const addonOfferToggle = $addonOfferToggle.getAttribute('aria-checked') === 'true'
      if (addonOfferToggle === true) {
        const $nectarAddonsContainer = document.querySelector('[data-nectar-addon-offer-toggle-container]')
        const $$nectarAddons = $nectarAddonsContainer.querySelectorAll('[name="nectar-addon-product"]')
        $$nectarAddons.forEach(($addon) => {
          if ($addon.value == '') return
          const variantId = parseInt($addon.value)
          if (isNaN(variantId)) {
            console.error('Invalid addon variant ID:', $addon.value)
            return
          }
          addToCartPayload.items.unshift({
            quantity: 1,
            id: variantId,
            properties: {
              _addon: true,
            },
          })
        })
      }
      const $$addons = document.querySelectorAll('[name="addon-product"]:checked')
      $$addons.forEach(($addon) => {
        if ($addon.value == '') return
        addToCartPayload.items.push({
          quantity: 1,
          id: Number($addon.value),
          properties: {
            _addon: true,
          },
        })
      })
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(addToCartPayload),
      })
        .then(async (response) => {
          if (!response.ok) {
            const error = await response.json()
            return alert(error.description || error.message)
          }

          const comparePopUp = document.querySelector('[data-compare-devices-modal]')
          if (comparePopUp) resetModal(comparePopUp)

          window.NSHybridCart.open()
        })
        .catch((response) => {
          console.error(response)
        })
        .finally(() => {
          delete $addToCartButton.dataset.loading
        })
    }

    $$addToCartButtons.forEach(($addToCartButton) => {
      $addToCartButton.addToCart = addToCart
      $addToCartButton.addEventListener('click', () => addToCart($addToCartButton))
    })
  }

  setupAddToCart() {
    const $$addToCartButtons = document.querySelectorAll('[data-add-to-cart]')

    $$addToCartButtons.forEach(($addToCartButton) =>
      $addToCartButton.addEventListener('click', () => {
        $addToCartButton.dataset.loading = null

        const addToCartPayload = this.buildAddToCartPayload()

        // Check if upsell modal should be triggered
        if (this.shouldTriggerUpsellModal(addToCartPayload)) {
          const upgradeMapping = this.getUpgradeMapping()
          if (upgradeMapping) {
            // Emit event to show upsell modal
            const upsellEvent = new CustomEvent('device-form:show-upsell', {
              detail: {
                addToCartData: addToCartPayload,
                upgradeMapping: upgradeMapping,
                button: $addToCartButton,
              },
            })
            document.dispatchEvent(upsellEvent)
            return // Don't proceed with ATC yet
          }
        }

        // Proceed with normal add to cart
        this.executeAddToCart(addToCartPayload, $addToCartButton)
      })
    )
  }

  buildAddToCartPayload() {
    const addToCartPayload = {
      items: [],
    }

    // Check for nectar upsell
    const $nectarToggle = document.querySelector('[data-nectar-addon-offer-toggle]')
    const hasNectarUpsell = $nectarToggle !== null
    const nectarToggleActive = hasNectarUpsell && $nectarToggle.getAttribute('aria-checked') === 'true'

    if (hasNectarUpsell) {
      // Use nectar variant mapping
      const variantMapping = this.getNectarVariantMapping()
      const productHandle = window.location.pathname.split('/').pop() // Get product handle from URL

      if (variantMapping[productHandle]) {
        const variantId = nectarToggleActive
          ? variantMapping[productHandle]['device-and-kit']
          : variantMapping[productHandle]['device-only']

        addToCartPayload.items.unshift({
          quantity: 1,
          id: Number(variantId),
        })
      } else {
        // Fallback to default behavior if product not in mapping
        addToCartPayload.items.unshift({
          quantity: 1,
          id: Number(this.getAttribute('variant-id')),
        })
      }
    } else {
      // Original logic for non-nectar products
      const $kit = this.querySelector('[name="kit"]:checked')
      if ($kit && $kit.value != '') {
        addToCartPayload.items.unshift({
          quantity: 1,
          id: Number($kit.value),
        })
      } else {
        addToCartPayload.items.unshift({
          quantity: 1,
          id: Number(this.getAttribute('variant-id')),
        })
      }
    }

    const $warranty = this.querySelector('[name="warranty"]:checked')
    if ($warranty && $warranty.value != '') {
      addToCartPayload.items.unshift({
        quantity: 1,
        id: Number($warranty.value),
      })
    }

    const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
    $$addons.forEach(($addon) => {
      if ($addon.value == '') return
      addToCartPayload.items.push({
        quantity: 1,
        id: Number($addon.value),
        properties: {
          _addon: true,
        },
      })
    })

    try {
      const autoAddons = JSON.parse(this.getAttribute('auto-addons'))
      autoAddons.forEach((addon) => {
        addToCartPayload.items.unshift(addon)
      })
    } catch (error) {
      console.error('Error parsing autoAddons:', error)
    }

    return addToCartPayload
  }

  executeAddToCart(addToCartPayload, $addToCartButton) {
    const warrantyIds = [40117523873827, 40117526167587, 40117524463651, 40559546564643, 40559548858403, 40559546630179]
    const hasWarranty = addToCartPayload.items.some((item) => warrantyIds.includes(item.id))

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(addToCartPayload),
    })
      .then(async (response) => {
        if (!response.ok) {
          const error = await response.json()
          return alert(error.description || error.message)
        }

        if (hasWarranty) window.igEvents.push({ event: 'warranty-added-to-cart' })
        window.NSHybridCart.open()
      })
      .catch((response) => {
        console.error('Error adding to cart:', response)
      })
      .finally(() => {
        delete $addToCartButton.dataset.loading
      })
  }

  shouldTriggerUpsellModal(addToCartPayload) {
    // Check Intelligems A/B test flag first
    if (window.showPreCartUpsell === false || window.showPreCartUpsell === undefined) {
      return false
    }

    // Check if upsell modal exists and is configured
    if (!window.PreCartUpsellModal || !window.PreCartUpsellModal.config) {
      return false
    }

    const baseProductVariants = window.PreCartUpsellModal.config.productData.baseProduct.variants
    const triggerVariantId = window.PreCartUpsellModal.triggerVariantId

    // If trigger variant ID is set, check against that specific variant
    if (triggerVariantId && triggerVariantId.trim() !== '') {
      return addToCartPayload.items.some((item) => item.id.toString() === triggerVariantId.toString())
    }

    // If no trigger variant ID is set, check if any payload variants match any baseProduct variants
    if (!baseProductVariants || !Array.isArray(baseProductVariants)) {
      return false
    }

    const baseProductVariantIds = baseProductVariants.map((variant) => variant.id.toString())
    return addToCartPayload.items.some((item) => baseProductVariantIds.includes(item.id.toString()))
  }

  getUpgradeMapping() {
    if (!window.PreCartUpsellModal || !window.PreCartUpsellModal.config) {
      return null
    }

    const config = window.PreCartUpsellModal.config
    const settings = config.settings

    // Check if upgrade mapping is configured
    if (!settings.upgrade_product) {
      console.error('[Pre-Cart Modal] No upgrade product configured')
      return null
    }

    // Get product data from the modal config
    const productData = config.productData || {}
    const upgradeProduct = productData.upgradeProduct
    const baseProduct = productData.baseProduct

    if (!upgradeProduct) {
      console.error('[Pre-Cart Modal] No upgrade product data found in modal config')
      return null
    }

    // Get the variant ID - use specified variant ID or first variant
    let upgradeVariantId = settings.upgrade_variant_id
    if (!upgradeVariantId && upgradeProduct.variants && upgradeProduct.variants.length > 0) {
      upgradeVariantId = upgradeProduct.variants[0].id
    }

    // Get base product variant ID if specified
    let baseVariantId = settings.base_variant_id
    if (!baseVariantId && baseProduct && baseProduct.variants && baseProduct.variants.length > 0) {
      baseVariantId = baseProduct.variants[0].id
    }

    const mapping = {
      baseProduct: {
        productHandle: settings.base_product,
        variantId: baseVariantId,
      },
      upgradeProduct: {
        productHandle: settings.upgrade_product,
        variantId: upgradeVariantId,
      },
      priceDifferenceText: settings.price_difference_text,
    }

    return mapping
  }

  setupUpsellModalListeners() {
    // Listen for upsell modal responses
    document.addEventListener('upsell-modal:upgrade-accepted', (e) => {
      const { originalData, upgradeMapping } = e.detail

      // Get the upgrade variant ID from the mapping
      // If no specific variant ID is set, we'll need to use the product ID (this should be handled in the mapping creation)
      const upgradeVariantId = upgradeMapping.upgradeProduct.variantId

      // Deep-clone to prevent accidental mutations of the original payload
      const upgradedPayload = JSON.parse(JSON.stringify(originalData))
      const mainProductIndex = upgradedPayload.items.findIndex(
        (item) =>
          item.id.toString() === this.getAttribute('variant-id') ||
          (upgradeMapping.baseProduct.variantId &&
            item.id.toString() === upgradeMapping.baseProduct.variantId.toString())
      )

      if (mainProductIndex !== -1 && upgradeVariantId) {
        upgradedPayload.items[mainProductIndex].id = Number(upgradeVariantId)
      } else {
        console.error('[Pre-Cart Modal] Could not find main product or upgrade variant ID missing')
      }

      // Add upsell acceptance property to all items
      upgradedPayload.items.forEach((item) => {
        item.properties = item.properties || {}
        item.properties._pre_cart_upsell_accepted = true
      })

      // upgrade essential warranty to pro warranty
      const essentialWarrantyId = 40117523873827
      const proWarrantyId = 40117524463651

      const warrantyIndex = upgradedPayload.items.findIndex(
        (item) => item.id.toString() === essentialWarrantyId.toString()
      )

      if (warrantyIndex !== -1) {
        upgradedPayload.items[warrantyIndex].id = Number(proWarrantyId)
      }

      if (warrantyIndex == -1) {
        console.warn('[Pre-Cart Modal] No warranty found')
      }

      // Execute add to cart with upgraded payload
      const $addToCartButton = document.querySelector('[data-add-to-cart][data-loading]')
      this.executeAddToCart(upgradedPayload, $addToCartButton)
    })

    document.addEventListener('upsell-modal:upgrade-declined', (e) => {
      const { originalData } = e.detail

      // Execute add to cart with original payload
      const $addToCartButton = document.querySelector('[data-add-to-cart][data-loading]')
      this.executeAddToCart(originalData, $addToCartButton)
    })
  }

  setupNectarUpsell() {
    const $addonOfferToggle = document.querySelector('[data-nectar-addon-offer-toggle]')
    const $addonOfferToggleContainer = document.querySelector('[data-nectar-addon-offer-toggle-container]')

    if (!$addonOfferToggle || !$addonOfferToggleContainer) {
      return // No nectar upsell on this page
    }

    // Set up toggle functionality

    $addonOfferToggle.addEventListener('click', () => {
      $addonOfferToggle.setAttribute(
        'aria-checked',
        $addonOfferToggle.getAttribute('aria-checked') === 'true' ? 'false' : 'true'
      )
      if ($addonOfferToggle.getAttribute('aria-checked') === 'true') {
        document.querySelectorAll('[data-nectar-addon-item] img').forEach(($addonItem) => {
          $addonItem.classList.remove('opacity-50')
          $addonOfferToggle.nextElementSibling.classList.add('opacity-0')
        })
        $addonOfferToggleContainer.classList.add('!border-red')
      } else {
        document.querySelectorAll('[data-nectar-addon-item] img').forEach(($addonItem) => {
          $addonItem.classList.add('opacity-50')
          $addonOfferToggle.nextElementSibling.classList.remove('opacity-0')
        })
        $addonOfferToggleContainer.classList.remove('!border-red')
      }
    })

    // Initialize addon item opacity
    document.querySelectorAll('[data-nectar-addon-item] img').forEach(($addonItem) => {
      $addonItem.classList.add('opacity-50')
    })

    // Update addons quantity display based on product
    this.updateNectarQuantityDisplay()
  }

  getNectarVariantMapping() {
    // Variant mapping from original nectar implementation
    return {
      'laser-hair-growth-system-essential': {
        'device-only': 40088010588195,
        'device-and-kit': 40088010620963,
      },
      'laser-hair-growth-system-professional': {
        'device-only': 40088010391587,
        'device-and-kit': 40143397355555,
      },
      'laser-hair-growth-system-elite': {
        'device-only': 40117636825123,
        'device-and-kit': 40143395487779,
      },
    }
  }

  getNectarAddonProducts() {
    // These would ideally come from product settings, but hardcoded for now as requested
    const addons = document.querySelectorAll('[data-nectar-addon-item]')
    const addon_items = {}
    addons.forEach((item) => {
      addon_items[item.dataset.handle].id = parseInt(item.dataset.variantId)
      addon_items[item.dataset.handle].quantity = 1
    })
    return addons
  }

  updateNectarQuantityDisplay() {
    const productHandle = window.location.pathname.split('/').pop()

    if (productHandle === 'laser-hair-growth-system-essential') {
      // Show 1x quantities for Essential
      document
        .querySelectorAll('[data-addons-quantity="1"]')
        .forEach(($addonsQuantity) => $addonsQuantity.classList.remove('!hidden'))
      document
        .querySelectorAll('[data-addons-quantity="3"]')
        .forEach(($addonsQuantity) => $addonsQuantity.classList.add('!hidden'))
    } else if (
      productHandle === 'laser-hair-growth-system-professional' ||
      productHandle === 'laser-hair-growth-system-elite'
    ) {
      // Show 3x quantities for Professional/Elite
      document
        .querySelectorAll('[data-addons-quantity="1"]')
        .forEach(($addonsQuantity) => $addonsQuantity.classList.add('!hidden'))
      document
        .querySelectorAll('[data-addons-quantity="3"]')
        .forEach(($addonsQuantity) => $addonsQuantity.classList.remove('!hidden'))
    }
  }

  setupPriceUpdating() {
    const $productVariantsData = this.querySelector('#product-variants-data')
    const productVariants = JSON.parse($productVariantsData.innerHTML)
    const automaticDiscount = Number(this.getAttribute('automatic-discount'))

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      trailingZeroDisplay: 'stripIfInteger',
    })

    const updatePrice = () => {
      const $kit = this.querySelector('[name="kit"]:checked')
      const $warranty = this.querySelector('[name="warranty"]:checked')
      const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
      const $purchaseOption = this.querySelector('[name="purchase-option"]:checked')?.parentElement

      let price = 0
      let compareAtPrice = 0
      let totalPrice = 0

      if ($purchaseOption && window.NOOD_TEST) {
        const $purchaseOptionPrice = $purchaseOption.querySelector('[data-purchase-option-price]')
        const $purchaseOptionComparePrice = $purchaseOption.querySelector('[data-purchase-option-compare-price]')

        price = parseFloat($purchaseOptionPrice.textContent.replace(/[^0-9.]/g, '')) * 100
        compareAtPrice = $purchaseOptionComparePrice
          ? parseFloat($purchaseOptionComparePrice.textContent.replace(/[^0-9.]/g, '')) * 100
          : 0
      } else {
        let variant = productVariants[0]
        if ($kit && $kit.value != '') {
          const foundVariant = productVariants.find((v) => v.id == $kit.value)
          if (!foundVariant) return console.error('Variant not found')
          variant = foundVariant
        }
        price += variant.price - automaticDiscount
        compareAtPrice += variant.compare_at_price || variant.price
      }

      totalPrice += price

      if ($warranty && $warranty.value != '') {
        totalPrice += parseInt($warranty.dataset.price) || 0
      }

      $$addons.forEach(($addon) => {
        if ($addon.value == '') return
        totalPrice += parseInt($addon.dataset.price) || 0
      })

      const $$price = document.querySelectorAll('[data-main-product-price]')
      const $$compareAtPrice = document.querySelectorAll('[data-main-product-compare-at-price]')
      const $$totalPrice = document.querySelectorAll('[data-main-product-total-price]')

      const formattedPrice = formatter.format(price / 100)
      $$price.forEach(($price) => {
        $price.innerHTML = formattedPrice
      })

      const formattedTotalPrice = formatter.format(totalPrice / 100)
      $$totalPrice.forEach(($totalPrice) => {
        $totalPrice.innerHTML = formattedTotalPrice
      })

      if (compareAtPrice > price) {
        const formattedCompareAtPrice = formatter.format(compareAtPrice / 100)
        $$compareAtPrice.forEach(($compareAtPrice) => {
          $compareAtPrice.innerHTML = formattedCompareAtPrice
          $compareAtPrice.classList.remove('hidden')
        })
      } else {
        $$compareAtPrice.forEach(($compareAtPrice) => $compareAtPrice.classList.add('hidden'))
      }

      // TEST - Update promo text
      function updatePromoText() {
        if (window.IG_TEST_PERCENT) {
          const $$promoText = document.querySelectorAll('[data-promo-text]')
          $$promoText.forEach(($promoText) => {
            if ($promoText.textContent.trim() == '') return

            let originalText
            if ($promoText.dataset.originalText) originalText = $promoText.dataset.originalText
            else $promoText.dataset.originalText = $promoText.textContent

            const priceMatch = $promoText.dataset.originalText.match(/\$([\d,.]+)/)
            if (priceMatch) $promoText.dataset.price = priceMatch[1]

            $promoText.dataset.price = parseFloat($promoText.dataset.price?.replace(',', ''))

            const percentOff = ($promoText.dataset.price / (compareAtPrice / 100)) * 100

            $promoText.textContent = `${$promoText.dataset.originalText.replace(/\$([\d,.]+)/, `${percentOff.toFixed(0)}%`)}`

            $promoText.dataset.loaded = true
          })
        }
      }

      if (!window.igData) {
        window.addEventListener('ig:ready', updatePromoText)
      } else {
        updatePromoText()
      }
    }

    const $$selectors = this.querySelectorAll(
      '[name="kit"], [name="warranty"], [name="addon-product"], [name="purchase-option"]'
    )
    $$selectors.forEach(($selector) => $selector.addEventListener('change', updatePrice))
    // init
    updatePrice()
  }

  setupVariantImageUpdating() {
    const hideImage = ($image) => {
      $image.classList.add('opacity-0')
      setTimeout(() => $image.classList.add('hidden'), 300)
    }

    const showImage = ($image) => {
      $image.classList.remove('hidden')
      setTimeout(() => $image.classList.remove('opacity-0'), 50)
    }

    const $section = this.closest('section')
    const $$kitSelectors = $section.querySelectorAll('[name="kit"]')
    $$kitSelectors.forEach(($kitSelector) => {
      $kitSelector.addEventListener('change', () => {
        // Desktop
        const $$desktopVariantImages = $section.querySelectorAll('[data-product-media-desktop] [data-variant-image]')
        if ($$desktopVariantImages.length === 0) return

        const position = $kitSelector.dataset.variantImage
        const $kitDesktopImage = $section.querySelector(
          '[data-product-media-desktop] [data-variant-image="' + position + '"]'
        )

        const $mainImage = $$desktopVariantImages[0].parentNode.querySelector('img:not([data-variant-image])')
        if (position === '') showImage($mainImage)
        else hideImage($mainImage)

        $$desktopVariantImages.forEach(($desktopVariantImage) => {
          if ($desktopVariantImage === $kitDesktopImage) return
          hideImage($desktopVariantImage)
        })

        if ($kitDesktopImage) showImage($kitDesktopImage)

        // Mobile
        const $mainMobileSplide = $section.querySelector('#product-media-splide')
        if (!$mainMobileSplide) return
        $mainMobileSplide.splide.go(parseInt(position) - 1 || 0)
      })
    })
  }
}

customElements.define('device-product-form', DeviceProductForm)
